$(document).ready(function() {
    // on page load
    var selectedVariantId = $('input[name="id"]').val();
    changeGallery(selectedVariantId);
  
  // on variant
    $('input[name="id"]').on('change', function(event) {
        selectedVariantId = $(this).val();
        changeGallery(selectedVariantId);
    });
});

function changeGallery(selectedVariantId) {
    $('.check-variant-images.sf-prod-media-item').hide();
    $('.img-'+selectedVariantId).show();
}